import React from "react";
import T from "prop-types";
import { Icon } from "MODULES/shared/components";
import DropDownItem from "../../../../../../shared/components/DropDown/DropDownItem";

function SendQualityControlDocuments({ open, lineItem }) {
  return (
    <DropDownItem onClick={() => open(lineItem)}>
      <Icon name="envelope" fixed />
      &nbsp;Send QC / Trace Docs
    </DropDownItem>
  );
}

export default SendQualityControlDocuments;

SendQualityControlDocuments.propTypes = {
  lineItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/SendQualityControlDocuments/SendQualityControlDocuments.jsx